import { Box } from '@wishket/design-system';
import { twMerge } from 'tailwind-merge';

import { LandingArticleBody } from './LandingArticleBody';
import ArticleCount from './ArticleCount';

import { ArticleAuthor } from '@/features/Article';
import { ScrapIconButton } from '@/shared/Components';
import { NewLandingArticleItemProps } from '@/shared/types';

const NewLandingArticleItem = ({
  countInfo,
  articleInfo,
  authorInfo,
  isUsingScrap = true,
  titleClassName,
  imageSize = 'sm',
  articleCountTypoClassName,
}: NewLandingArticleItemProps) => {
  const isUsingCount = !!countInfo;
  const isUsingAuthor = !!authorInfo;

  return (
    <Box
      className="flex w-full justify-between gap-3"
      data-testid="landing-article-item"
    >
      {isUsingCount && (
        <ArticleCount
          {...countInfo}
          articleCountTypoClassName={articleCountTypoClassName}
        />
      )}
      <Box
        className={twMerge(
          'flex flex-col gap-1.5',
          isUsingCount ? 'w-[calc(100%_-_40px)]' : 'w-full'
        )}
      >
        <LandingArticleBody
          {...articleInfo}
          titleClassName={titleClassName}
          imageSize={imageSize}
        />
        {isUsingAuthor && (
          <Box className="relative flex items-center justify-between gap-2">
            <ArticleAuthor {...authorInfo} />
            {isUsingScrap && (
              <ScrapIconButton
                id={articleInfo.id}
                initialIsScrapped={articleInfo.isScrapped}
                scrapBoxPositionClass="right-0"
                data-testid="landing-article-scrap-button"
              />
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default NewLandingArticleItem;
